import { CharacterMetadata } from '@wix/draft-js';
/**
 * Removes all styles not present in the whitelist.
 * NOTE this is pretty much the draftjs filters version just using regex instead of string
 */
export var filterInlineStyles = function (whitelist, content) {
    var blockMap = content.getBlockMap();
    var blocks = blockMap.map(function (block) {
        var altered = false;
        if (!block) {
            return block;
        }
        var chars = block.getCharacterList().map(function (char) {
            var newChar = char;
            if (!char) {
                return char;
            }
            char
                .getStyle()
                .filter(function (type) { return !whitelist.find(function (ok) { return ok.test(type); }); })
                .forEach(function (type) {
                altered = true;
                newChar = CharacterMetadata.removeStyle(newChar, type);
            });
            return newChar;
        });
        return altered ? block.set('characterList', chars) : block;
    });
    return content.merge({
        blockMap: blockMap.merge(blocks),
    });
};
//# sourceMappingURL=filterInlineStyles.js.map